export default [
  {
    text: 'Name',
    value: 'name',
    apiSort: 'firstname',
  },
  {
    text: 'Email',
    value: 'email',
  },
  {
    text: 'Created',
    value: 'created_at',
    apiSort: 'created_at',
  },
  {
    text: 'Role Status',
    value: 'status.name',
    apiSort: 'role_user.status',
    // align: 'end',
    tooltip: 'BusinessMembersTablesStatus',
  },
  {
    text: 'Role',
    value: 'role.name',
    apiSort: 'roles.name',
    // align: 'end',
    tooltip: 'BusinessMembersTablesRole',
  },
];
